import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openCustomDialog } from '../../../redux/slices/customDialogSlice';
import ProductEdit from '../../../app/product/productForm/ProductEdit';
import useContextForm from '../../../app/contacts/useContextForm';

const EditProductAction = ({ payload, onComplete }) => {
    const dispatch = useDispatch();
    
    const formConfigProduct = useContextForm({ type: 'product_extra_fields' });
    
    const formConfigProductVariant = useContextForm({ type: 'product_variant_extra_fields' });
    
    useEffect(() => {
        if (formConfigProduct !== undefined && formConfigProductVariant !== undefined) {
            const onCancel = onComplete ? () => onComplete(null) : undefined;
            dispatch(
                openCustomDialog(
                    <ProductEdit
                        product={payload}
                        formConfigProduct={formConfigProduct}
                        formConfigProductVariant={formConfigProductVariant}
                        canEdit={true}
                        onCancel={onCancel}
                        onComplete={onComplete}
                    />,
                    {
                        beforeClose: onCancel,
                    },
                ),
            );
        }
        // eslint-disable-next-line
    }, [formConfigProduct, formConfigProductVariant]);
};

export default EditProductAction;
